import { render } from "./UserDocuments.vue?vue&type=template&id=054cc03d&scoped=true&ts=true"
import script from "./UserDocuments.vue?vue&type=script&lang=ts"
export * from "./UserDocuments.vue?vue&type=script&lang=ts"

import "./UserDocuments.vue?vue&type=style&index=0&id=054cc03d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054cc03d"]])

export default __exports__